const siteId = process.env.REACT_APP_BUILD_SITE;

const realEstateTypesByPortal = {
  ZPAR: {
    realEstateTypes: [
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Departamento',
        id: '2'
      },
      {
        name: 'Terreno',
        id: '26'
      },
      {
        name: 'PH',
        id: '2001'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Oficina comercial',
        id: '4'
      },
      {
        name: 'Edificio',
        id: '7'
      },
      {
        name: 'Bodega/Galpón',
        id: '8'
      },
      {
        name: 'Garage',
        id: '32'
      },
      {
        name: 'Consultorio',
        id: '10'
      },
      {
        name: 'Depósito',
        id: '45'
      },
      {
        name: 'Quinta vacacional',
        id: '11'
      },
      {
        name: 'Fondo de comercio',
        id: '99'
      },
      {
        name: 'Cama naútica',
        id: '2005'
      },
      {
        name: 'Hotel',
        id: '38'
      },
      {
        name: 'Campo',
        id: '14'
      },
      {
        name: 'Bóveda/Nicho/Parcela',
        id: '2000'
      }
    ],
    realEstateSubTypes: [
      {
        name: 'Apartestudio',
        id: '100'
      },
      {
        name: 'Dúplex',
        id: '40'
      },
      {
        name: 'Estándar',
        id: '38'
      },
      {
        name: 'Loft',
        id: '39'
      },
      {
        name: 'Monoambiente',
        id: '111'
      },
      {
        name: 'Penthouse',
        id: '37'
      },
      {
        name: 'Piso',
        id: '36'
      },
      {
        name: 'Semipiso',
        id: '35'
      },
      {
        name: 'Tríplex',
        id: '34'
      },
      {
        name: 'Barrio con acceso controlado',
        id: '41'
      },
      {
        name: 'Bungalow',
        id: '110'
      },
      {
        name: 'Cabaña',
        id: '42'
      },
      {
        name: 'Casa de playa',
        id: '1'
      },
      {
        name: 'Chalet',
        id: '43'
      },
      {
        name: 'Condominio',
        id: '44'
      },
      {
        name: 'Dúplex',
        id: '45'
      },
      {
        name: 'PH',
        id: '47'
      },
      {
        name: 'Prefabricada',
        id: '48'
      },
      {
        name: 'Tríplex',
        id: '50'
      },
      {
        name: 'Bóveda',
        id: '18'
      },
      {
        name: 'Nicho',
        id: '19'
      },
      {
        name: 'Parcela',
        id: '20'
      }
    ]
  },
  '24MX': {
    realEstateTypes: [
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Departamento',
        id: '2'
      },
      {
        name: 'Terreno/Lote',
        id: '3'
      },
      {
        name: 'Oficina comercial',
        id: '4'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Edificio',
        id: '7'
      },
      {
        name: 'Bodega-Galpón',
        id: '8'
      },
      {
        name: 'Quinta',
        id: '11'
      },
      {
        name: 'Casa en condominio',
        id: '12'
      },
      {
        name: 'Departamento compartido',
        id: '13'
      },
      {
        name: 'Rancho',
        id: '14'
      },
      {
        name: 'Villa',
        id: '15'
      },
      {
        name: 'Casa uso de suelo',
        id: '16'
      },
      {
        name: 'Huerta',
        id: '17'
      },
      {
        name: 'Inmueble productivo urbano',
        id: '18'
      },
      {
        name: 'Local en centro comercial',
        id: '19'
      },
      {
        name: 'Terreno comercial',
        id: '20'
      },
      {
        name: 'Bodega comercial',
        id: '21'
      },
      {
        name: 'Nave industrial',
        id: '22'
      },
      {
        name: 'Terreno industrial',
        id: '24'
      },
      {
        name: 'Desarrollo horizontal',
        id: '33'
      },
      {
        name: 'Desarrollo vertical',
        id: '34'
      },
      {
        name: 'Desarrollo horizontal-vertical',
        id: '35'
      },
      {
        name: 'Dúplex',
        id: '101'
      }
    ]
  },
  VAMX: {
    realEstateTypes: [
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Departamento',
        id: '2'
      },
      {
        name: 'Terreno/Lote',
        id: '3'
      },
      {
        name: 'Oficina comercial',
        id: '4'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Edificio',
        id: '7'
      },
      {
        name: 'Bodega-Galpón',
        id: '8'
      },
      {
        name: 'Quinta',
        id: '11'
      },
      {
        name: 'Casa en condominio',
        id: '12'
      },
      {
        name: 'Departamento compartido',
        id: '13'
      },
      {
        name: 'Rancho',
        id: '14'
      },
      {
        name: 'Villa',
        id: '15'
      },
      {
        name: 'Casa uso de suelo',
        id: '16'
      },
      {
        name: 'Huerta',
        id: '17'
      },
      {
        name: 'Inmueble productivo urbano',
        id: '18'
      },
      {
        name: 'Local en centro comercial',
        id: '19'
      },
      {
        name: 'Terreno comercial',
        id: '20'
      },
      {
        name: 'Bodega comercial',
        id: '21'
      },
      {
        name: 'Nave industrial',
        id: '22'
      },
      {
        name: 'Terreno industrial',
        id: '24'
      },
      {
        name: 'Desarrollo horizontal',
        id: '33'
      },
      {
        name: 'Desarrollo vertical',
        id: '34'
      },
      {
        name: 'Desarrollo horizontal-vertical',
        id: '35'
      },
      {
        name: 'Dúplex',
        id: '101'
      }
    ]
  },
  IWBR: {
    realEstateTypes: [
      {
        name: 'Apartamento',
        id: '2'
      },
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Comercial',
        id: '1005'
      },
      {
        name: 'Rural',
        id: '1004'
      },
      {
        name: 'Terreno',
        id: '1003'
      }
    ],
    realEstateSubTypes: [
      {
        name: 'Cobertura',
        id: '26'
      },
      {
        name: 'Duplex',
        id: '34'
      },
      {
        name: 'Flat',
        id: '4'
      },
      {
        name: 'Garden',
        id: '38'
      },
      {
        name: 'Kitnet/Studio',
        id: '2'
      },
      {
        name: 'Loft',
        id: '3'
      },
      {
        name: 'Padrão',
        id: '1'
      },
      {
        name: 'Quarto',
        id: '36'
      },
      {
        name: 'Triplex',
        id: '35'
      },
      {
        name: 'Casa de condomínio',
        id: '6'
      },
      {
        name: 'Casa de vila',
        id: '7'
      },
      {
        name: 'Padrão',
        id: '5'
      },
      {
        name: 'Quarto',
        id: '37'
      },
      {
        name: 'Sobrado',
        id: '33'
      },
      {
        name: 'Andar',
        id: '30'
      },
      {
        name: 'Box/Garagem',
        id: '14'
      },
      {
        name: 'Casa comercial',
        id: '17'
      },
      {
        name: 'Clínica',
        id: '29'
      },
      {
        name: 'Conjunto comercial/sala',
        id: '16'
      },
      {
        name: 'Consultório',
        id: '28'
      },
      {
        name: 'Galpão/Depósito/Barracão',
        id: '20'
      },
      {
        name: 'Hotel',
        id: '22'
      },
      {
        name: 'Indústria',
        id: '25'
      },
      {
        name: 'Loja de shopping/Centro comercial',
        id: '18'
      },
      {
        name: 'Loja/Salão',
        id: '19'
      },
      {
        name: 'Motel',
        id: '23'
      },
      {
        name: 'Ponto comercial',
        id: '31'
      },
      {
        name: 'Pousada/Chalé',
        id: '24'
      },
      {
        name: 'Prédio inteiro',
        id: '15'
      },
      {
        name: 'Área comercial',
        id: '32'
      },
      {
        name: 'Área industrial',
        id: '27'
      },
      {
        name: 'Chácara',
        id: '10'
      },
      {
        name: 'Fazenda',
        id: '12'
      },
      {
        name: 'Haras',
        id: '13'
      },
      {
        name: 'Sítio',
        id: '11'
      },
      {
        name: 'Loteamento/Condomínio',
        id: '9'
      },
      {
        name: 'Terreno padrão',
        id: '8'
      }
    ]
  },
  CMBR: {
    realEstateTypes: [
      {
        name: 'Apartamento',
        id: '2'
      },
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Comercial',
        id: '1005'
      },
      {
        name: 'Rural',
        id: '1004'
      },
      {
        name: 'Terreno',
        id: '1003'
      }
    ],
    realEstateSubTypes: [
      {
        name: 'Cobertura',
        id: '26'
      },
      {
        name: 'Duplex',
        id: '34'
      },
      {
        name: 'Flat',
        id: '4'
      },
      {
        name: 'Garden',
        id: '38'
      },
      {
        name: 'Kitnet/Studio',
        id: '2'
      },
      {
        name: 'Loft',
        id: '3'
      },
      {
        name: 'Padrão',
        id: '1'
      },
      {
        name: 'Quarto',
        id: '36'
      },
      {
        name: 'Triplex',
        id: '35'
      },
      {
        name: 'Casa de condomínio',
        id: '6'
      },
      {
        name: 'Casa de vila',
        id: '7'
      },
      {
        name: 'Padrão',
        id: '5'
      },
      {
        name: 'Quarto',
        id: '37'
      },
      {
        name: 'Sobrado',
        id: '33'
      },
      {
        name: 'Andar',
        id: '30'
      },
      {
        name: 'Box/Garagem',
        id: '14'
      },
      {
        name: 'Casa comercial',
        id: '17'
      },
      {
        name: 'Clínica',
        id: '29'
      },
      {
        name: 'Conjunto comercial/sala',
        id: '16'
      },
      {
        name: 'Consultório',
        id: '28'
      },
      {
        name: 'Galpão/Depósito/Barracão',
        id: '20'
      },
      {
        name: 'Hotel',
        id: '22'
      },
      {
        name: 'Indústria',
        id: '25'
      },
      {
        name: 'Loja de shopping/Centro comercial',
        id: '18'
      },
      {
        name: 'Loja/Salão',
        id: '19'
      },
      {
        name: 'Motel',
        id: '23'
      },
      {
        name: 'Ponto comercial',
        id: '31'
      },
      {
        name: 'Pousada/Chalé',
        id: '24'
      },
      {
        name: 'Prédio inteiro',
        id: '15'
      },
      {
        name: 'Área comercial',
        id: '32'
      },
      {
        name: 'Área industrial',
        id: '27'
      },
      {
        name: 'Chácara',
        id: '10'
      },
      {
        name: 'Fazenda',
        id: '12'
      },
      {
        name: 'Haras',
        id: '13'
      },
      {
        name: 'Sítio',
        id: '11'
      },
      {
        name: 'Loteamento/Condomínio',
        id: '9'
      },
      {
        name: 'Terreno padrão',
        id: '8'
      }
    ]
  },
  WIBR: {
    realEstateTypes: [
      {
        name: 'Apartamento',
        id: '2'
      },
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Comercial',
        id: '1005'
      },
      {
        name: 'Rural',
        id: '1004'
      },
      {
        name: 'Terreno',
        id: '1003'
      }
    ],
    realEstateSubTypes: [
      {
        name: 'Cobertura',
        id: '26'
      },
      {
        name: 'Duplex',
        id: '34'
      },
      {
        name: 'Flat',
        id: '4'
      },
      {
        name: 'Garden',
        id: '38'
      },
      {
        name: 'Kitnet/Studio',
        id: '2'
      },
      {
        name: 'Loft',
        id: '3'
      },
      {
        name: 'Padrão',
        id: '1'
      },
      {
        name: 'Quarto',
        id: '36'
      },
      {
        name: 'Triplex',
        id: '35'
      },
      {
        name: 'Casa de condomínio',
        id: '6'
      },
      {
        name: 'Casa de vila',
        id: '7'
      },
      {
        name: 'Padrão',
        id: '5'
      },
      {
        name: 'Quarto',
        id: '37'
      },
      {
        name: 'Sobrado',
        id: '33'
      },
      {
        name: 'Andar',
        id: '30'
      },
      {
        name: 'Box/Garagem',
        id: '14'
      },
      {
        name: 'Casa comercial',
        id: '17'
      },
      {
        name: 'Clínica',
        id: '29'
      },
      {
        name: 'Conjunto comercial/sala',
        id: '16'
      },
      {
        name: 'Consultório',
        id: '28'
      },
      {
        name: 'Galpão/Depósito/Barracão',
        id: '20'
      },
      {
        name: 'Hotel',
        id: '22'
      },
      {
        name: 'Indústria',
        id: '25'
      },
      {
        name: 'Loja de shopping/Centro comercial',
        id: '18'
      },
      {
        name: 'Loja/Salão',
        id: '19'
      },
      {
        name: 'Motel',
        id: '23'
      },
      {
        name: 'Ponto comercial',
        id: '31'
      },
      {
        name: 'Pousada/Chalé',
        id: '24'
      },
      {
        name: 'Prédio inteiro',
        id: '15'
      },
      {
        name: 'Área comercial',
        id: '32'
      },
      {
        name: 'Área industrial',
        id: '27'
      },
      {
        name: 'Chácara',
        id: '10'
      },
      {
        name: 'Fazenda',
        id: '12'
      },
      {
        name: 'Haras',
        id: '13'
      },
      {
        name: 'Sítio',
        id: '11'
      },
      {
        name: 'Loteamento/Condomínio',
        id: '9'
      },
      {
        name: 'Terreno padrão',
        id: '8'
      }
    ]
  },
  PLEC: {
    realEstateTypes: [
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Departamento',
        id: '2'
      },
      {
        name: 'Terreno/Lote',
        id: '3'
      },
      {
        name: 'Oficina comercial',
        id: '4'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Hacienda/Quinta',
        id: '6'
      },
      {
        name: 'Edificio/Hotel/Fábrica',
        id: '7'
      },
      {
        name: 'Bodega/Galpón',
        id: '8'
      },
      {
        name: 'Suite',
        id: '9'
      },
      {
        name: 'Consultorio',
        id: '10'
      },
      {
        name: 'Quinta vacacional',
        id: '11'
      },
      {
        name: 'Habitación',
        id: '25'
      },
      {
        name: 'Parqueadero',
        id: '32'
      }
    ]
  },
  CAPA: {
    realEstateTypes: [
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Apartamento',
        id: '2'
      },
      {
        name: 'Terreno/Lote',
        id: '3'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Oficina comercial',
        id: '4'
      },
      {
        name: 'Finca',
        id: '6'
      },
      {
        name: 'Edificio',
        id: '7'
      },
      {
        name: 'Bodega/Galpón/Depósito',
        id: '8'
      },
      {
        name: 'Consultorio médico',
        id: '10'
      },
      {
        name: 'Habitación',
        id: '25'
      },
      {
        name: 'Hotel',
        id: '38'
      },
      {
        name: 'Isla',
        id: '44'
      }
    ]
  },
  UBPE: {
    realEstateTypes: [
      {
        name: 'Departamento',
        id: '2'
      },
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Terreno/Lote',
        id: '3'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Oficina',
        id: '4'
      },
      {
        name: 'Nave industrial',
        id: '22'
      },
      {
        name: 'Casa de playa',
        id: '27'
      },
      {
        name: 'Casa de campo',
        id: '28'
      },
      {
        name: 'Cochera',
        id: '32'
      },
      {
        name: 'Hotel',
        id: '38'
      },
      {
        name: 'Habitación',
        id: '25'
      },
      {
        name: 'Terreno agrícola',
        id: '26'
      },
      {
        name: 'Otros',
        id: '29'
      }
    ]
  },
  DVPE: {
    realEstateTypes: [
      {
        name: 'Departamento',
        id: '2'
      },
      {
        name: 'Casa',
        id: '1'
      },
      {
        name: 'Terreno/Lote',
        id: '3'
      },
      {
        name: 'Local comercial',
        id: '5'
      },
      {
        name: 'Oficina',
        id: '4'
      },
      {
        name: 'Nave industrial',
        id: '22'
      },
      {
        name: 'Casa de playa',
        id: '27'
      },
      {
        name: 'Casa de campo',
        id: '28'
      },
      {
        name: 'Cochera',
        id: '32'
      },
      {
        name: 'Hotel',
        id: '38'
      },
      {
        name: 'Habitación',
        id: '25'
      },
      {
        name: 'Terreno agrícola',
        id: '26'
      },
      {
        name: 'Otros',
        id: '29'
      }
    ]
  }
};

/**
 * Obtiene el nombre del realEstateType por ID y portal
 * @param {string} id - El ID del tipo de inmueble
 * @returns {string|null} El nombre del tipo de inmueble o null si no se encuentra
 */
function getRealEstateTypeName(id) {
  if (!realEstateTypesByPortal[siteId] || !realEstateTypesByPortal[siteId].realEstateTypes) {
    return null;
  }

  const realEstateType = realEstateTypesByPortal[siteId].realEstateTypes.find(type => type.id === id);
  return realEstateType ? realEstateType.name : null;
}

/**
 * Obtiene el nombre del realEstateSubType por ID y portal
 * @param {string} id - El ID del subtipo de inmueble
 * @returns {string|null} El nombre del subtipo de inmueble o null si no se encuentra
 */
function getRealEstateSubTypeName(id) {
  if (!realEstateTypesByPortal[siteId] || !realEstateTypesByPortal[siteId].realEstateSubTypes) {
    return null;
  }

  const realEstateSubType = realEstateTypesByPortal[siteId].realEstateSubTypes.find(subType => subType.id === id);
  return realEstateSubType ? realEstateSubType.name : null;
}

export { getRealEstateTypeName, getRealEstateSubTypeName };
